// extracted by mini-css-extract-plugin
export default {"checkbox":"z2URfH","checkboxError":"mRs8z3"};